export default __webpack_public_path__ + "static/media/m4dz.ad29175a.mp4";